import React from 'react'
import GenericPullAndPushToolView from '../GenericPullAndPushToolView'
import WhiteHatSentinelConfigListing from './WhiteHatSentinelConfigListing'
import WhiteHatSentinelCredentialsForm from './WhiteHatSentinelCredentialsForm'

export default function WhiteHatSentinelPullAndPushView(props) {
    return (
        <GenericPullAndPushToolView 
            {...props}
            PullCredentialForm={WhiteHatSentinelCredentialsForm}
            PullConfigListingView={WhiteHatSentinelConfigListing}
        />
    )
}